import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_OperatorPrecedenceParsing = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Operator Precedence Parsing"
    videos={[
      "https://www.youtube.com/embed/aMKJC6P_psE",
      "https://www.youtube.com/embed/7K2U4Otqhpk",
    ]}
    takeaways={[
      { text: "Learn both operator precedence parser and operator precedence function" },
    ]}
    questions={[
      "Compare and contrast the operator relation table and operator function table with a suitable example.",
      "Construct the operator precedence relation table for the following CFG where S is the starting symbol. Parse the string a+b*c using the relation table constructed.\n\nS->SAS|(S)|S\nA->+|*",
      `Consider the following grammar: Perform operator precedence parsing for the input string "id1 / id2 - id3". Provide a step-by-step explanation of how the operator precedence parser processes this input.

E->E-E
E->E/E
E->id`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_OperatorPrecedenceParsing;
